import styled from 'styled-components';

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fb;
  border-radius: 6px;
  width: 7.5rem;
  height: 7.5rem;

  > * {
    max-width: 90%;
    max-height: 90%;
  }
`;
